import React from "react";
import Clear from "@mui/icons-material/Clear";
import styles from "./TopHeader.module.css"; // Create a CSS module for styling
import IconButton from "@mui/material/IconButton";

interface TopHeaderProps {
  onClose: () => void;
}

const TopHeader: React.FC<TopHeaderProps> = ({ onClose }) => {
  return (
    <div className={styles.topHeader}>
      <h2>Selecciona tu ubicación</h2>
      <IconButton className={styles.closeButton} onClick={onClose}>
        <Clear /> {/* Material UI close icon */}
      </IconButton>
    </div>
  );
};

export default TopHeader;
